<template>
  <footer>
    <div class="container">
      <div class="footer">
        <div class="header">
          <div class="logo">
            <img
              src="/img/logos/iba-logo-slogan.svg"
              alt="IBA Global healing"
            />
          </div>
          <div class="texts mt-14" style="width:100%">
            <div class="social-media">
              <a href="https://www.facebook.com/thebodytalksystem" target="_blank">
                <img src="/img/icons/facebook-circle.svg" alt="Facebook" />
              </a>
              <a class="ml-3 mr-2" href="https://x.com/BodyTalkSystem" target="_blank">
                <!-- <img src="/img/icons/twitter-circle.svg" alt="Twitter" /> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="#222222"
                  class=""
                  viewBox="0 0 24 24"
                >
                  <path 
                    d="M12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z" fill="#222222" fill-opacity="0.7"
                  />
                  <path
                    d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" transform="scale(0.6) translate(12,12)" fill="#222222" fill-opacity="0.7"
                  />
                </svg>
              </a>
              <a href="https://www.youtube.com/@thebodytalksystem" target="_blank">
                <img src="/img/icons/youtube-circle.svg" alt="Youtube" />
              </a>
              <a href="https://www.instagram.com/bodytalksystem/" target="_blank" class="mx-3">
                <span>
                  <img
                    src="/img/icons/instagram.svg"
                    alt="Instagram"
                    width="20px"
                    height="20px"
                  />
                </span>
              </a>
            </div>
          </div>
        </div>
        <div class="links column-one">
          <div class="title"><b>Support</b></div>
          <!-- <div class="item-link"   v-if="this.$route.path === '/managemembership'" >
            <a class="link hover-linear"  @click="membershipNewsToggle = true">
              Cancel Membership
            </a>
          </div> -->
          <div class="item-link">
            <a class="link hover-linear" @click="contactusmodel()">
              Contact Us
            </a>
          </div>
          <div class="item-link">
                <router-link to="/ethics">
            <a class="link hover-linear"> <ChangeLanguageComponent :langName="languageObject.Ethics"/> </a>
            </router-link>
          </div>
          <!-- Commented because not required for phase 1 -->

          <!-- <div class="item-link">
            <router-link to="/helpcenter">
              <a class="link hover-linear"> Help Center </a>
            </router-link>
          </div> -->

          <!-- <div class="item-link">
            <a class="link hover-linear"> Media Kit </a>
          </div> -->
        </div>
        <div class="links column-two">
          <div class="title"><b><ChangeLanguageComponent :langName="languageObject.Legal" /></b></div>
          
          <div class="item-link">
            <router-link to="/privacypolicy">
              <a class="link hover-linear"> Privacy Policy </a>
            </router-link>
          </div>
          <div class="item-link">
            <router-link to="/termsandconditions">
              <a class="link hover-linear"> Terms and Conditions </a>
            </router-link>
          </div>
        </div>
      </div>
      <div class="sub-footer">
        <p class="body-2">
          Copyright @ 2005 - {{ currentYear }} International <ChangeLanguageComponent :langName="languageObject.BodyTalk"/> Association (IBA)
        </p>

        <!-- <div class="powered">
          <p class="body-2">

        <div class="powered d-flex align-center">
          <a href="https://agencycoda.com/" class="mr-2" target="_blank">
            <img src="img/logos/coda-favicon.svg" alt="Agengy Coda" />
          </a>
          <p class="body-2 ">
            Powered by
            <a
              href="https://agencycoda.com/"
              target="_blank"
              class="link hover-linear"
            >
              Agency Coda
            </a>
          </p>
          <a href="https://agencycoda.com/" target="_blank">
            <img src="img/logos/coda-favicon.svg" alt="Agengy Coda" />
          </a>
        </div> -->
      </div>
    </div>
    <!------------Contact us diloag--------------------------->
    <ContactUsComponent></ContactUsComponent>
      
    <v-dialog v-model="aoturenewldialog" class="" max-width="500">
      <v-card class="px-5 pa-4">
        <div class="d-flex justify-end">
          <v-icon @click="aoturenewldialog = false">mdi-close </v-icon>
        </div>
        <div class="py-5">
          <div class=" d-flex justify-center" style="text-align: center">
            <span class="h2"
              ><b>Cancellation successful</b>
            </span>
            </div>
            <div class="py-4 d-flex justify-center" style="text-align: center" >
            <span class="h3"
              >Your auto-renewals for yearly membership have been turned off.
            </span>
          </div>
          <div
            class="py-3 d-flex justify-center align center px-5"
            style="text-align: center"
          >
            Restore membership anytime by returning to your membership management page and clicking Renew.
          </div>
        </div>
      </v-card>
    </v-dialog>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ContactUsComponent from "../../components/Contactus/Contactus.component.vue";
import ChangeLanguageComponent from "../../components/HomePage/ChangeLanguage.Component.vue";
import languageObject from "../../utils/index";
import { mapGetters } from "vuex";
export default defineComponent({
  name: "Footer",
  components: { ContactUsComponent, ChangeLanguageComponent },
  data() {
    return { 
      btnloader: false,
      languageObject, 
      showpage: false, 
      aoturenewldialog : false,
    };
  },
  computed: {
    ...mapGetters(["GetUser",]),
    currentYear() {
      return new Date().getFullYear(); // Get the current year
    },
  },

  methods: {
    contactusmodel() {
      this.$store.dispatch("ToggleContact", true);
    },
    
  },
});
</script>

